import { EmployeeSummaryDto } from './employee-summary-dto.model';
import { TransactionStatus } from '../service-proxies';


export class WorkFromHomeDto implements IWorkFromHomeDto {
    id!: number;
    employee!: EmployeeSummaryDto;
    approver!: EmployeeSummaryDto;
    fromDateTime!: Date;
    toDateTime!: Date;
    workFromHomeRequestDate!: Date;
    reason!: string | undefined;
    status!: TransactionStatus;

    constructor(data?: IWorkFromHomeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employee = _data["employee"] ? EmployeeSummaryDto.fromJS(_data["employee"]) : <any>undefined;
            this.approver = _data["approver"] ? EmployeeSummaryDto.fromJS(_data["approver"]) : <any>undefined;
            this.fromDateTime = _data["fromDateTime"] ? new Date(_data["fromDateTime"].toString()) : <any>undefined;
            this.toDateTime = _data["toDateTime"] ? new Date(_data["toDateTime"].toString()) : <any>undefined;
            this.workFromHomeRequestDate = _data["workFromHomeRequestDate"] ? new Date(_data["workFromHomeRequestDate"].toString()) : <any>undefined;
            this.reason = _data["reason"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): WorkFromHomeDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkFromHomeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["approver"] = this.approver ? this.approver.toJSON() : <any>undefined;
        data["fromDateTime"] = this.fromDateTime ? this.fromDateTime.toISOString() : <any>undefined;
        data["toDateTime"] = this.toDateTime ? this.toDateTime.toISOString() : <any>undefined;
        data["workFromHomeRequestDate"] = this.workFromHomeRequestDate ? this.workFromHomeRequestDate.toISOString() : <any>undefined;
        data["reason"] = this.reason;
        data["status"] = this.status;
        return data; 
    }
}

export interface IWorkFromHomeDto {
    id: number;
    employee: EmployeeSummaryDto;
    approver: EmployeeSummaryDto;
    fromDateTime: Date;
    toDateTime: Date;
    workFromHomeRequestDate: Date;
    reason: string | undefined;
    status: TransactionStatus;
}

